import { Images as ChingariImages } from "./chingari.io";
import { Images as AstroImages } from "./astrolive.app";

export const getDomainImages = () => {
  if (typeof window !== "undefined") {
    if (window?.location?.hostname?.includes("astrolive")) {
      return AstroImages;
    }
  }

  return ChingariImages;
};

export const getImagesFromDomain = (hostname: string) => {
  if (hostname?.includes("astrolive")) return AstroImages;
  return ChingariImages;
};
